// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pervasives from "../../../../rescript/lib/es6/pervasives.js";
import * as Caml_option from "../../../../rescript/lib/es6/caml_option.js";
import * as DateTime$Catalyst from "./DateTime.bs.js";
import * as ErrorUtils$Catalyst from "./ErrorUtils.bs.js";

function getStringFrmOptionalType(data) {
  if (data !== undefined) {
    return data;
  } else {
    return "N/A";
  }
}

function getEmptyStringFrmOptionalType(data) {
  if (data !== undefined) {
    return data;
  } else {
    return "";
  }
}

function getIntFrmOptionalType(data) {
  if (data !== undefined) {
    return data;
  } else {
    return 0;
  }
}

function getIntFrmOptionalTypeStrict(data) {
  if (data !== undefined) {
    return data;
  } else {
    return ErrorUtils$Catalyst.raiseError("OptionTypeUtils.getIntFrmOptionalTypeStrict", "No integer found", "");
  }
}

function getFloatFrmOptionalTypeStrict(data) {
  if (data !== undefined) {
    return data;
  } else {
    return ErrorUtils$Catalyst.raiseError("OptionTypeUtils.getFloatFrmOptionalTypeStrict", "No Float found", "");
  }
}

function getDateFrmOptionalType(data) {
  if (data !== undefined) {
    return Caml_option.valFromOption(data);
  } else {
    return new Date("N/A");
  }
}

function getDateStringFromOptionType(date) {
  if (date !== undefined) {
    return DateTime$Catalyst.toString("Do MMM YY HH:mm", Caml_option.valFromOption(date));
  } else {
    return "N/A";
  }
}

function getDateFromOptionalString(date, format) {
  if (date !== undefined) {
    return Caml_option.some(DateTime$Catalyst.fromString(format, date));
  }
  
}

function optionResolver($$case) {
  if ($$case !== undefined) {
    return Caml_option.valFromOption($$case);
  } else {
    return Pervasives.failwith("not found");
  }
}

function getListFromOptionalType(li) {
  if (li !== undefined) {
    return li;
  } else {
    return /* [] */0;
  }
}

var OptionMomentToMomentMap = {};

export {
  getStringFrmOptionalType ,
  getEmptyStringFrmOptionalType ,
  getIntFrmOptionalType ,
  getIntFrmOptionalTypeStrict ,
  getFloatFrmOptionalTypeStrict ,
  getDateFrmOptionalType ,
  getDateStringFromOptionType ,
  getDateFromOptionalString ,
  optionResolver ,
  getListFromOptionalType ,
  OptionMomentToMomentMap ,
  
}
/* DateTime-Catalyst Not a pure module */
